import axiosInstance from '../Config/AxiosInstance';

const PREFIX = `/clinic/scribe`;

export const listAll = () => {
  return axiosInstance.get(PREFIX);
};

export const AddScribe = data => {
  return axiosInstance.post(PREFIX, data);
};

export const editScribe = data => {
  return axiosInstance.put(PREFIX, data);
};

export const fetchUnassignedAuthors = () => {
  return axiosInstance.get(PREFIX + '/unassigned-authors');
};

export const fetchAssignedAuthor = () => {
  return axiosInstance.get(PREFIX + '/assigned-author');
};
